import { render, staticRenderFns } from "./AlunosParecerAEEouACP.vue?vue&type=template&id=0d330538&"
import script from "./AlunosParecerAEEouACP.vue?vue&type=script&lang=js&"
export * from "./AlunosParecerAEEouACP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports